import { Box, Stack, Typography } from '@mui/material';

export type OpsStackedSegment = {
  key: string;
  value: number;
  color: string;
  label: string;
};

type OpsStackedBarProps = {
  label: string;
  segments: OpsStackedSegment[];
  total: number;
  height?: number;
};

export default function OpsStackedBar({ label, segments, total, height = 8 }: OpsStackedBarProps) {
  const scale = total > 0 ? total : segments.reduce((sum, s) => sum + s.value, 0) || 1;

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 0.25 }}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
          {total}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          height,
          borderRadius: 0.5,
          overflow: 'hidden',
          bgcolor: 'action.hover',
        }}
      >
        {segments.map((segment) =>
          segment.value > 0 ? (
            <Box
              key={segment.key}
              title={`${segment.label}: ${segment.value}`}
              sx={{
                width: `${(segment.value / scale) * 100}%`,
                bgcolor: segment.color,
                minWidth: segment.value > 0 ? 2 : 0,
              }}
            />
          ) : null,
        )}
      </Box>
      <Stack direction="row" spacing={1} sx={{ mt: 0.25 }} flexWrap="wrap">
        {segments
          .filter((s) => s.value > 0)
          .map((segment) => (
            <Typography key={segment.key} variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
              {segment.label} {segment.value}
            </Typography>
          ))}
      </Stack>
    </Box>
  );
}
